import actions from './actions';

export const initialState = {
  dashboardUrl: '',
  details: { x: 0, y: 0, scrollY: 0, content: {} },
  deviceType: null,
  equipmentType: '',
  items: null,
  isTransition: false,
  loading: false,
  softwareNumber: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.dashboardUrl:
      return {
        ...state,
        dashboardUrl: action.value
      };
    case actions.details:
      return {
        ...state,
        details: action.value
      };
    case actions.deviceType:
      return {
        ...state,
        deviceType: action.value
      };
    case actions.equipmentType:
      return {
        ...state,
        equipmentType: action.value
      };
    case actions.items:
      return {
        ...state,
        loading: false,
        items: action.value
      };
    case actions.isTransition:
      return {
        ...state,
        isTransition: action.value
      };
    case actions.loading:
      return {
        ...state,
        loading: true
      };
    case actions.softwareNumber:
      return {
        ...state,
        softwareNumber: action.value
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/views/dashboard/reducer.js